import { useEffect, useState } from "react";
import { publicApi } from "../lib/publicApi";

/** Shared, lightweight settings hook for the public site (no auth). */
export default function usePublicSettings() {
  const [settings, setSettings] = useState(null);
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await publicApi.get("/settings");
        setSettings(data);
        if (data?.favicon_url) {
          const link = document.querySelector('link[rel="icon"]') || document.createElement("link");
          link.rel = "icon";
          link.href = data.favicon_url;
          document.head.appendChild(link);
        }
        if (data?.showroom_name) document.title = data.showroom_name;
      } catch (err) {
        if (err?.response?.status === 404) setEnabled(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { settings, enabled, loading };
}

export function fmtMoney(v, settings) {
  if (v == null || v === "") return null;
  const sym = settings?.currency_symbol || settings?.currency_code || "OMR";
  const dec = settings?.currency_decimals ?? 3;
  try {
    return `${sym} ${Number(v).toLocaleString(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec })}`;
  } catch {
    return `${sym} ${v}`;
  }
}

export function pickPhoto(v, size = "card") {
  const primary = (v?.photos || []).find((p) => p.is_primary) || (v?.photos || [])[0];
  if (!primary) return null;
  return primary.variants?.[size] || primary.thumbnail_url || primary.url;
}

/** srcset/sizes for a photo's WebP renditions (400 / 800 / 1600 px). */
export function photoSrcSet(p, sizes = "(max-width: 700px) 100vw, 400px") {
  const v = p?.variants || {};
  const parts = [[v.thumbnail, 400], [v.card, 800], [v.full, 1600]].filter(([u]) => u).map(([u, w]) => `${u} ${w}w`);
  return parts.length ? { srcSet: parts.join(", "), sizes } : {};
}

export function primaryPhoto(v) {
  return (v?.photos || []).find((p) => p.is_primary) || (v?.photos || [])[0] || null;
}
